import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderModePipe } from './order-mode.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    OrderModePipe
  ],
  exports: [
    OrderModePipe
  ]
})
export class OrderModeModule { }
